import styled from "styled-components";

export const AccountTilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
